module.exports = __webpack_public_path__ + "img/costValue.96b2fe86.png";